module.exports = __webpack_public_path__ + "static/media/brego3591.380373e3.jpg";